import { useTranslation } from "react-i18next";
import { LifeBuoy, Mail } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { SUPPORT_EMAIL, supportMailto } from "../../config/support";
import { useMyCompany } from "../../api/useMyCompany";
import { CompanySerial } from "./CompanySerial";

// جهة اتصال دعم ظاهرة داخل التطبيق (مطلوبة من آبل 1.5 وGoogle Play).
export const SupportCard = () => {
  const { t } = useTranslation();
  const company = useMyCompany();
  const serial = company?.serial;

  return (
    <NeuCard data-testid="support-card">
      <div className="flex items-start justify-between gap-3">
        <p className="label-xs">{t("support.title")}</p>
        <LifeBuoy className="h-5 w-5 text-primary" />
      </div>
      <p className="mt-3 text-xs leading-6 text-muted-foreground">{t("support.note")}</p>
      <CompanySerial serial={serial} className="mt-4" />
      {serial ? (
        <p className="mt-2 text-[11px] leading-6 text-muted-foreground">{t("support.serialHint")}</p>
      ) : null}
      <a
        href={supportMailto(serial ? `HELCOO Support · #${serial}` : "HELCOO Support")}
        className="neu-in mt-4 flex items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold text-primary"
        data-testid="support-email-link"
      >
        <Mail className="h-4 w-4" />
        {SUPPORT_EMAIL}
      </a>
    </NeuCard>
  );
};
